import React from "react"
import { useSelector } from "react-redux"
import { Button, TextField, Paper, Typography } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Form } from "formik";
import { typeAPI } from "../services/TypeAPI";
import * as Yup from "yup";
import Swal from 'sweetalert2'
import { authAPI } from "../services/AuthAPI";
import './edittype.css'

const AddPrefix = ({ isMobile, closeNav }) => {
    const navigate = useNavigate();
    const { isLoading } = useSelector(state => state.user)

    const FormSchema = Yup.object().shape({
        org_name: Yup.string()
            .min(3, "ป้อนรหัสผ่านอย่างน้อย 5 หลัก")
            .max(255, "ป้อนรหัสผ่านสูงสุด 255 หลัก")
            .trim()
            .required("ป้อนชื่อบริษัทของคุณ"),
    }
    );

    const useStyles = makeStyles(theme => ({
        leftIcon: {
            marginRight: theme.spacing(1)
        },
        root: {
            padding: theme.spacing(4, 3)
        },
        container: {
            display: "block",
            flexWrap: "wrap"
        },
        textField: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            marginTop: theme.spacing(1),
            width: 400
        },
        button: {
            marginTop: theme.spacing(2)
        },
        mt_1: {
            margin: theme.spacing(3)
        }
    }));

    const classes = useStyles();

    return (
        !isLoading && <Formik
            validationSchema={FormSchema}
            initialValues={{ org_name: "", prefix: "" }}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    setSubmitting(true)
                    Swal.fire({
                        title: `ยืนยันที่จะเพิ่ม ${values.org_name} ?`,
                        confirmButtonColor: "#6ab23a",
                        showCancelButton: true,
                        confirmButtonText: "OK!",
                    }).then(result => {
                        if (result.isConfirmed) {
                            authAPI.createPrefix({ org_name: values.org_name, prefixZ: values.prefix })
                                .then((res) => {
                                    if (res.status == 200) {
                                        Swal.fire({
                                            icon: 'success',
                                            confirmButtonColor: "#6ab23a",
                                            text: `เพิ่ม ${values.org_name} เรียบร้อยแล้ว`,
                                            timer: 5000
                                        }).then(() => {
                                            navigate('/manage-prefix')
                                        })
                                    }
                                    else {
                                        Swal.fire({
                                            icon: 'error',
                                            confirmButtonColor: "#6ab23a",
                                            text: `${res.message}`,
                                            timer: 5000
                                        })
                                    }
                                    setSubmitting(false)
                                })
                                .catch((error) => {
                                    Swal.fire({
                                        icon: 'error',
                                        confirmButtonColor: "#6ab23a",
                                        text: `${error.message}`,
                                        timer: 5000
                                    })
                                    setSubmitting(false)
                                })
                        }
                    })
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "red",
                        text: error.message,
                        timer: 5000
                    })
                }
            }}
        >
            {({
                values,
                handleChange,
                isSubmitting,
                touched,
                errors,
            }) => (
                <Form className='container h-100vh' style={{ display:closeNav ? 'block':isMobile?'none':'block', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-end', padding: !isMobile ? 'none':'0' }}>
                    <Paper className={`${classes.root} col-root`} style={{ boxShadow: 'none', padding: '3%'}}>
                        <h3 style={{ fontSize: '38px'}}>เพิ่ม Prefix</h3>
                        <TextField
                            label="Org Name"
                            className={`${classes.textField} textField`}
                            helperText="ชื่อสำนักงานที่โชว์ในหน้า Login"
                            name={"org_name"}
                            value={values.org_name}
                            onChange={handleChange}
                        />
                        <TextField
                            label="Prefix Value"
                            className={`${classes.textField} textField`}
                            helperText="Value ที่ใส่ต่อท้าย User เวลา Login และ ค้นหาไฟล์ในหน้าขอเอกสาร"
                            name={"prefix"}
                            value={values.prefix}
                            onChange={handleChange}
                        />
                        <Typography component="div">
                            {errors.org_name && touched.org_name ? (
                                <div style={{ color: "#FF3333" }}>{errors.org_name}</div>
                            ) : null}
                            {errors.prefix && touched.prefix ? (
                                <div style={{ color: "#FF3333" }}>{errors.prefix}</div>
                            ) : null}

                        </Typography>
                        <Button
                            type="submit"
                            disabled={isSubmitting}
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: "#6ab23a", color: 'white', cursor: 'pointer', marginTop: '4%'
                            }}
                            className={classes.button}
                        >
                            บันทึก
                        </Button>
                    </Paper>
                </Form>)}
        </Formik>
    )
}
export default AddPrefix